import { useEffect } from "react";
import CustomersSegment from "./segments/customers/customers";
import FeaturesSegment from "./segments/features/features";
import FlowSegment from "./segments/flow/flow";
import HeroSegment from "./segments/hero/hero";
import Navbar from "./segments/navbar/navbar";
import PrecisionSegment from "./segments/precision/precision-segment";
import { useLocation } from "react-router-dom";
import FAQSegment from "./segments/faq/faq";
import { PricingSegment } from "./segments/pricing/pricing";
import { ContactUsSegment } from "./segments/contact-us/contact-us";
import PrivacySegment from "./segments/privacy/privacy-segment";
import ScrollToTop from "../../molecules/scrollToTop/scrollToTop";

const LandingPage = () => {
    const location = useLocation();
    
    useEffect(() => {
        const element = document.getElementById('pricing');

        if (location.hash === "#pricing") {
            element.scrollIntoView()
        }
    });

    return (
        <>
            <ScrollToTop />
            <Navbar />
            <HeroSegment />
            <CustomersSegment />
            <PrecisionSegment />
            <PrivacySegment />
            <FlowSegment />
            <FeaturesSegment />
            <PricingSegment />
            <FAQSegment />
            <ContactUsSegment />
        </>
    );
};

export default LandingPage;

{/* AI screenshot (multi language) */}
{/* Follow up questions */}
{/* Follow up checklist */}
{/* Fact check */}
{/* Language check & improvements */}
{/* Technical terms */}